import * as configLocal from '../config.local';
import * as configProd from '../config.prod';

export default process.env.NODE_ENV === 'production' ? configProd : configLocal;
